/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import logo from '../logo.svg';
import { useAppSelector } from '../hooks/redux-hooks';
import { APP_TITLE, PAGE_TITLE_HOME } from '../utils/constants';

export const Home = () => {
	const user = useAppSelector((state) => state.user.user);

	return (
		<>
			<Helmet>
				<title>
					{PAGE_TITLE_HOME} | {APP_TITLE}
				</title>
			</Helmet>
			<Typography variant='h4'>{`Hello, ${user?.name}`}</Typography>
			<div
				css={css`
					text-align: center;
					margin-top: 6rem;
				`}>
				<img
					css={css`
						height: 40vmin;
						pointer-events: none;
						@media (prefers-reduced-motion: no-preference) {
							animation: App-logo-spin infinite 15s linear;
						}
						@keyframes App-logo-spin {
							from {
								transform: rotate(0deg);
							}
							to {
								transform: rotate(360deg);
							}
						}
					`}
					src={logo}
					alt='logo'
				/>
			</div>
		</>
	);
};
